module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal modal-pendency fade",
    attrs: {
      "id": "modal-pendency",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "smart-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.__fields_group2), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({}),
        expression: "{}"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "lazy": field.lazy,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.concluir
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Fechar pendência\n          ")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields_group1), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.name !== 'employee_assigned_id' ? 'required' : {}),
        expression: "field.name !== 'employee_assigned_id' ? 'required': {}"
      }],
      ref: 'ref_' + field.name,
      refInFor: true,
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly || (typeof(_vm.private_id) !== 'undefined' && field.name === 'employee_assigned_id' && !_vm.profile.map['vehicle-entries'].includes('change-assigned-employee-pendencies')),
        "lazy": field.lazy,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-1"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), (!_vm.private_id) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 5px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Criar nova pendência\n          ")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "4px 5px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar pendência\n          ")])])], 2)]), _vm._v(" "), (_vm.pendencies.length) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.pendencies), function(pendency) {
    return _c('tr', {
      class: !pendency.completed_at ? 'danger' : 'success'
    }, [_c('td', [_vm._v(_vm._s(pendency.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.category_pendency_vehicle.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.occurrence))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.prediction_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.completed_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.employee.name))]), _vm._v(" "), _c('td', [(!pendency.completed_at && Number(_vm.user.id) === Number(pendency.assigned_employee.id_key)) ? _c('a', {
      staticClass: "btn btn-primary padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar")]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete-pendencies')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.drop(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir")]) : _vm._e()])])
  }), 0)]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-lg text-primary fa-inbox"
  }), _vm._v(" Não existem pendências para este veículo!\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" Fechamento de Pendência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Voltar\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Tipo de Pendência")]), _vm._v(" "), _c('th', [_vm._v("Ocorrência")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Previsão")]), _vm._v(" "), _c('th', [_vm._v("Encerrado Em")]), _vm._v(" "), _c('th', [_vm._v("Encerrado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0209c37e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Edit/PendencyForm.vue
// module id = 953
// module chunks = 1